import React from 'react';
import DatabaseService from '../services/DatabaseService';

const SalesList = ({ sales, onEdit, onDelete, onRefresh, onViewDetails, onForceDelete }) => {
  console.log('SalesList: Rendering with sales:', sales);

  const handleDelete = async (id) => {
    if (window.confirm('ยืนยันการลบการขายหรือไม่ หลังจากลบแล้ว สถานะใบเสนอราคาจะกลับไปเป็น pending')) {
      try {
        console.log('SalesList: Calling onDelete for ID:', id);
        await onDelete(id);
        console.log('SalesList: Delete completed successfully');
      } catch (error) {
        console.error('Error deleting sale:', error);

        // แสดงข้อความแจ้งเตือนที่เข้าใจง่าย
        if (error.message.includes('PM Schedule') || error.message.includes('ปฏิทิน')) {
          alert('ไม่สามารถลบข้อมูลได้\n\nกรุณาลบ PM Schedule ในปฏิทินออกก่อน จึงจะสามารถลบรายการขายนี้ได้');
        } else {
          alert('เกิดข้อผิดพลาดในการลบข้อมูล: ' + error.message);
        }
      }
    }
  };



  if (!sales || sales.length === 0) {
    return (
      <div className="card">
        <div className="card-body text-center">
          <p className="mb-0">ไม่มีข้อมูลการขาย</p>
        </div>
      </div>
    );
  }

  // Function to get product type label
  const getProductTypeLabel = (type) => {
    switch (type) {
      case 'battery':
        return 'แบตเตอรี่';
      case 'charger':
        return 'ชาร์จเจอร์';
      case 'mixed':
        return 'แบตเตอรี่+ชาร์จเจอร์';
      case 'service':
        return 'บริการ';
      default:
        return type || 'ไม่ระบุ';
    }
  };



  // Function to calculate total quantity of battery and charger items
  const calculateProductQuantity = (sale) => {
    if (!sale.items || !Array.isArray(sale.items)) {
      return 0;
    }
    return sale.items
      .filter(item => item.product_type === 'battery' || item.product_type === 'charger')
      .reduce((total, item) => total + (parseInt(item.quantity) || 0), 0);
  };

  // Function to get mixed product types from items
  const getProductTypesFromItems = (sale) => {
    if (!sale.items || !Array.isArray(sale.items)) {
      return 'ไม่ระบุ';
    }

    const types = [...new Set(sale.items.map(item => item.product_type).filter(Boolean))];

    if (types.length === 0) return 'ไม่ระบุ';
    if (types.length === 1) return getProductTypeLabel(types[0]);

    const typeLabels = types.map(type => getProductTypeLabel(type));
    return typeLabels.join(' + ');
  };

  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <div>
          <h5 className="mb-0">รายการการขาย ({sales.length} รายการ)</h5>
          <small className="text-muted">
            อัปเดตล่าสุด: {new Date().toLocaleTimeString('th-TH')} |
            IDs: {sales.map(s => s.id).join(', ')}
          </small>
        </div>
        <button className="btn btn-outline-primary btn-sm" onClick={onRefresh}>
          รีเฟรช
        </button>
      </div>
      <div className="card-body">
        <div className="table-responsive">
          <table className="table table-striped table-hover">
            <thead className="table-dark">
              <tr>
                <th>เลขที่</th>
                <th>วันที่ขาย</th>
                <th>วันที่ส่งมอบ</th>
                <th>เลขที่ใบเสนอราคา</th>
                <th>ชื่อลูกค้า</th>
                <th>ประเภทสินค้า</th>
                <th>จำนวนสินค้า</th>
                <th>ยอดรวมเงิน</th>
                <th>สถานะการขาย</th>
                <th>ชื่อพนักงานขาย</th>
                <th>จัดการ</th>
              </tr>
            </thead>
            <tbody>
              {sales.map((sale) => (
                <tr key={sale.id}>
                  {/* เลขที่การขาย */}
                  <td>
                    <code className="text-success fw-bold">
                      {sale.sale_number || `SL-${new Date().getFullYear().toString().slice(-2)}${String(sale.id).padStart(3, '0')}`}
                    </code>
                  </td>

                  {/* วันที่ขาย */}
                  <td>{DatabaseService.formatDate(sale.saleDate)}</td>

                  {/* วันที่ส่งมอบ */}
                  <td>{sale.delivery_date || sale.deliveryDate ? DatabaseService.formatDate(sale.delivery_date || sale.deliveryDate) : '-'}</td>

                  {/* เลขที่ใบเสนอราคา */}
                  <td>
                    <code className="text-primary">
                      {sale.quotation_number || sale.quotationNumber || `QT-${DatabaseService.formatDate(sale.saleDate).replace(/\//g, '')}-${String(sale.id).padStart(2, '0')}`}
                    </code>
                  </td>

                  {/* ชื่อลูกค้า */}
                  <td>
                    <strong>{sale.customerName || '-'}</strong>
                  </td>

                  {/* ประเภทสินค้า */}
                  <td>
                    <span className="badge bg-info">
                      {getProductTypesFromItems(sale)}
                    </span>
                  </td>

                  {/* จำนวนสินค้า */}
                  <td className="text-center">
                    <span className="badge bg-secondary">
                      {calculateProductQuantity(sale)} ชิ้น
                    </span>
                  </td>

                  {/* ยอดรวมเงิน */}
                  <td className="text-end">
                    <strong className="text-success">
                      {DatabaseService.formatCurrency(sale.saleAmount || sale.total_amount || 0)}
                    </strong>
                  </td>

                  {/* สถานะการขาย */}
                  <td>
                    <span className={`badge ${sale.status === 'สำเร็จ' ? 'bg-success' :
                      sale.status === 'รอดำเนินการ' ? 'bg-warning' :
                        sale.status === 'ยกเลิก' ? 'bg-danger' :
                          'bg-secondary'
                      }`}>
                      {sale.status || 'ไม่ระบุ'}
                    </span>
                  </td>

                  {/* ชื่อพนักงานขาย */}
                  <td>
                    {sale.salesperson || sale.sales_person || '-'}
                  </td>

                  {/* จัดการ */}
                  <td>
                    <div className="btn-group btn-group-sm" role="group">
                      <button
                        className="btn btn-outline-info"
                        onClick={() => onViewDetails(sale)}
                        title="ดูรายละเอียด"
                      >
                        <i className="fas fa-eye me-1"></i>ดู
                      </button>
                      <button
                        className="btn btn-outline-danger"
                        onClick={() => onForceDelete && onForceDelete(sale)}
                        title="ลบรายการขาย"
                      >
                        <i className="fas fa-trash"></i>ลบ
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Summary */}
        <div className="row mt-3">
          <div className="col-md-12">
            <div className="alert alert-info">
              <div className="row">
                <div className="col-md-3">
                  <strong>จำนวนการขายทั้งหมด:</strong> {sales.length} รายการ
                </div>
                <div className="col-md-3">
                  <strong>ยอดขายรวม:</strong> {DatabaseService.formatCurrency(
                    sales.reduce((sum, sale) => sum + (parseFloat(sale.saleAmount) || 0), 0)
                  )}
                </div>
                <div className="col-md-3">
                  <strong>ส่วนลดรวม:</strong> {DatabaseService.formatCurrency(0)}
                </div>
                <div className="col-md-3">
                  <strong>ยอดสุทธิรวม:</strong> {DatabaseService.formatCurrency(
                    sales.reduce((sum, sale) => sum + (parseFloat(sale.saleAmount) || 0), 0)
                  )}
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-4">
                  <strong>สำเร็จ:</strong> {sales.filter(s => s.status === 'สำเร็จ').length} รายการ
                </div>
                <div className="col-md-4">
                  <strong>รอดำเนินการ:</strong> {sales.filter(s => s.status === 'รอดำเนินการ').length} รายการ
                </div>
                <div className="col-md-4">
                  <strong>ยกเลิก:</strong> {sales.filter(s => s.status === 'ยกเลิก').length} รายการ
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesList;